import { Button, Container, Paper, Text } from "@mantine/core";
import { useForm, useWatch } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";

import { usePatchWorkspace } from "../../../api/workspace";
import { web_workspaceSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

export default function EditForm({ data, isSysAdmin }) {
  const { id, name } = data;

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      name: name,
    },
    resolver: resolver(web_workspaceSchema),
  });

  const watchedName = useWatch({ control, name: "name" });
  const dirty = watchedName !== name;

  const { mutate, isPending: isLoading } = usePatchWorkspace({
    id,
    onSuccess: (updatedWorkspace) => {
      reset({ name: updatedWorkspace.name });
    },
  });

  return (
    <Container size={700}>
      <Paper withBorder shadow="md" p={16} mt={16} radius="md">
        <form onSubmit={handleSubmit(mutate)}>
          <TextInput
            label="Name"
            type="text"
            name="name"
            control={control}
            withAsterisk
            mt="md"
            disabled={!isSysAdmin}
          />
          {!isSysAdmin && (
            <Text size="md" c="red" mt="md">
              Only system admins can edit workspaces!
            </Text>
          )}
          <Button
            type="submit"
            mt="md"
            loading={isLoading}
            disabled={!isSysAdmin || !dirty}
          >
            Edit workspace
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
